import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { H3 } from "../components/typography"
import { BaseContainer } from "../components/container"
import NotFoundIllustration from "../components/notFound/image"

const NotFoundPage = () => (
  <Layout>
    <SEO title="404: Not found" />
    <BaseContainer direction="vertical" halign="center">
      <H3>صفحه پیدا نشد</H3>
      <NotFoundIllustration />
    </BaseContainer>
  </Layout>
)

export default NotFoundPage
